import * as React from "react";
import { Activity, RefreshCw, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const benefits = [{
  title: "Fraction of the Fee",
  description: "Traditional brokers charge exorbitant percentages. We match you with qualified buyers at a significantly lower cost, keeping more equity in your pocket.",
  icon: RefreshCw
}, {
  title: "Accurate Valuation",
  description: "Leverage our specialized data to understand the true market value of your MSP, ensuring you don't leave money on the table during negotiations.",
  icon: Activity
}, {
  title: "Direct Connections",
  description: "Skip the middleman. We facilitate direct introductory calls between IT business owners and serious buyers for a streamlined acquisition process.",
  icon: ShieldCheck
}];
export default function WorkflowBenefits() {
  return <section data-section-id="241535" id="why-choose-buymymsp" className="py-20 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, i) => <Card key={i} data-index={i} className="border-border shadow-sm hover:shadow-xl transition-all duration-300 bg-card hover:scale-[1.02] border-t-4 border-t-primary">
              <CardHeader className="pb-4">
                <div className="flex items-center justify-center size-14 rounded-lg bg-primary/5 text-primary mb-4">
                  <benefit.icon className="size-7" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-default font-bold tracking-tight text-foreground">
                  {benefit.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground font-default leading-relaxed">
                  {benefit.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}